import { INgayNghi } from "../../../models/response/category/INgayNghi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objNgayNghiDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: [] as INgayNghi[],
    LOAD_ERROR: "",
    LOAD_COSO_START: {} as number,
    LOAD_COSO_SUCCESS: [] as INgayNghi[],
    LOAD_COSO_ERROR: "",
    SHOW_EDIT_MODAL: {} as INgayNghi | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as INgayNghi,
    SAVE_SUCCESS: {} as INgayNghi,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: ""
};

export const eNgayNghiActionTypeIds = generateActionTypeIds(objNgayNghiDefine, "NGAY_NGHI")
export type INgayNghiActionTypes = IGenericActionType<typeof objNgayNghiDefine, "NGAY_NGHI">
